/* eslint-disable global-require */

import React from 'react';
import ReactDOM from 'react-dom';
import * as FullStory from '@fullstory/browser';

import App from './App';

const MOUNT_NODE = document.getElementById('root');

let render = () => {
  // const routes = require('./routes/index').default(store);
  if (window.__CONFIG__.FULL_STORY_TRACKING_ENABLED) {
    FullStory.init({ orgId: window.__CONFIG__.FULL_STORY_ORG_ID || null });
  }
  ReactDOM.render(<App />, MOUNT_NODE);
};

if (process.env.NODE_ENV === 'development') {
  if (module.hot) {
    const renderApp = render;
    const renderError = (error) => {
      ReactDOM.render(<App error={error} />, MOUNT_NODE);
    };

    render = () => {
      try {
        renderApp();
      } catch (error) {
        renderError(error);
      }
    };

    module.hot.accept();
  }
}

render();
